import React from "react"

function Star({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.8523 11.2178C18.8523 11.2178 20.0697 15.259 20.3579 16.2135C20.3927 16.3322 20.502 16.4136 20.6263 16.4136C21.8635 16.4136 28.1989 16.4136 28.1989 16.4136"
        stroke="#003E4C"
        strokeWidth="0.991706"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 16.4122H15.1254C15.2446 16.4122 15.354 16.3367 15.3937 16.2233C15.831 14.9565 18.3204 7.76367 18.3204 7.76367"
        stroke="#003E4C"
        strokeWidth="0.991706"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1319 18.8303C10.1319 18.8303 13.2175 20.7394 13.9976 21.2246C14.107 21.2901 14.1566 21.4182 14.1218 21.5387C13.8734 22.4294 12.8846 26.012 12.4473 27.594C12.4175 27.7085 12.4573 27.8307 12.5567 27.8992C12.6511 27.9677 12.7803 27.9677 12.8796 27.8992C14.251 26.9352 17.3964 24.7228 18.1517 24.1885C18.251 24.1183 18.3852 24.1207 18.4845 24.1939C19.2398 24.7599 22.405 27.1377 23.7914 28.179C23.8857 28.2516 24.0199 28.2546 24.1193 28.1873C24.2187 28.1194 24.2634 27.9966 24.2336 27.8803C23.7765 26.2097 22.738 22.3993 22.4845 21.469C22.4497 21.3462 22.5044 21.2164 22.6138 21.152C23.4237 20.6786 26.6037 18.8203 26.6037 18.8203"
        stroke="#003E4C"
        strokeWidth="0.991706"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Star
